import { posthogService } from "../services/posthogService";
import { OverrunThreshold } from "../types/enums";

export function useTaskCompletion() {
  function toggleTaskCompleted(task: any) {
    let updatedTask = { ...task, completed: !task.completed };

    // If marking as completed, end any active session
    if (
      updatedTask.completed &&
      updatedTask.sessions &&
      updatedTask.sessions.length > 0
    ) {
      const sessions = [...updatedTask.sessions];
      const lastSession = sessions[sessions.length - 1];

      // If the last session doesn't have an end time, set it to current time
      if (!lastSession.endTime) {
        sessions[sessions.length - 1] = {
          ...lastSession,
          endTime: new Date().toISOString(),
        };

        // Recalculate duration based on all sessions
        const totalDuration = sessions.reduce((total, session) => {
          if (!session.endTime) return total;
          return (
            total +
            (new Date(session.endTime).getTime() -
              new Date(session.startTime).getTime())
          );
        }, 0);

        updatedTask = {
          ...updatedTask,
          sessions,
          duration: totalDuration,
        };
      }
    }

    // Track task completion in PostHog
    if (updatedTask.completed && updatedTask.estimatedDuration > 0) {
      posthogService.trackTaskCompleted(
        updatedTask.name,
        updatedTask.duration,
        updatedTask.estimatedDuration
      );
    }

    return updatedTask;
  }

  function checkForTaskCompletion(task: any) {
    if (
      task.completed &&
      task.estimatedDuration > 0 &&
      task.duration !== undefined
    ) {
      const overrunThreshold =
        task.estimatedDuration * OverrunThreshold.PERCENTAGE; // 20% longer

      if (task.duration > overrunThreshold) {
        // Task is overrun - return overrun data
        return {
          isOverrun: true,
          taskName: task.name,
          estimatedDuration: task.estimatedDuration,
          actualDuration: task.duration,
        };
      } else {
        // Task is on time - return success data
        const accuracy = (task.duration / task.estimatedDuration) * 100;
        return {
          isOverrun: false,
          taskName: task.name,
          accuracy,
        };
      }
    }
    return null;
  }

  return {
    toggleTaskCompleted,
    checkForTaskCompletion,
  };
}
